<template>
  <div class="dialog-container dialog-light chart-of-accounts">
    <div class="review-excel-dialog">
      <div class="dialog-header">
      <ax-dialog-header
        text="Multiple Xero Organisations"
        :type="'profile'"
        :description="'Can only connect to Sinchii with one Xero Organisation at a time. Please select an organisation below. (note, organisations used by other accounts will not appear in this list)'"
      ></ax-dialog-header>

      </div>
      <div class="dialog-body pb-0">
        <div class="mb-0">
          <div class="card-body">
            <div class="review-import-form">
              <!-- data row -->
              <k-dropdown-list
                :label="'Organisations'"
                :data-items="connectionData"
                :data-item-key="'tenantId'"
                :text-field="'tenantName'"
                v-model="connection" />
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="row justify-content-center pt-3">
          <k-button
            variant="secondary"
            class="btn btn-lg btn-secondary w-100"
            @click="select()"
          >Continue</k-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();

export default({
  name: "multiple-connections",
  props: {
    connectionData: Array
  },
  data() {
    return {
      modalContent: {
        title: "Select Organisation to Connect",
        description: ""
      },
      connection: null
    }
  },
  methods: {
    async select() {
      if (this.connection) {
        this.$emit("onClickSubmitChosenConnection", this.connection);
      } else {
        toast.clear();
        toast.error("Select an organisation.");
      }
    }
  }
})
</script>
